import { PessoaBaseModel } from '../../../core/models/pessoa.model';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { EnumDataset } from '../../../core/enums/enum-dataset';
import { SpeedDialModule } from 'primeng/speeddial';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { TitleComponent } from '../../../core/componentes/Title/title.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { PlanoService } from '../service/plano.service';
import { PlanoModel } from '../models/plano.model';
import { DialogModule } from 'primeng/dialog';
import { getEnumValues } from '../../../core/tools/helper.tools';
import { EnumSimNao } from '../../../core/enums/enum-simnao';

@Component({
  selector: 'app-listar-planos',
  templateUrl: './listar-planos.gestao.html',
  styleUrl: './listar-planos.gestao.scss',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    InputTextModule,
    FloatLabelModule,
    ReactiveFormsModule,
    DropdownModule,
    InputMaskModule,
    SpeedDialModule,
    TableModule,
    ToastModule,
    TagModule,
    TitleComponent,
    InputNumberModule,
    DialogModule,
  ],
})
export class ListarPlanosGestao implements OnInit {
  public translate = inject(TranslateService);
  constructor(private formBuilder: FormBuilder, private router: Router) {}

  //#region Service
  planoService = inject(PlanoService);
  //#endregion

  //#region Inicialização
  token: string = sessionStorage.getItem(EnumDataset.dataSetLogin) || '';
  value: string = '';
  filtroForm: FormGroup = this.initFiltroFormulario();
  formAddPlano: FormGroup = this.initAddPlanoFormulario();
  planos: PlanoModel[] = [];
  showAddPlano: boolean = false;
  simNaoConst = getEnumValues(EnumSimNao);

  initFiltroFormulario() {
    this.filtroForm = this.formBuilder.group({
      id: null,
      nome: [''],
      sistema: [''],
    });

    return this.filtroForm;
  }
  initAddPlanoFormulario() {
    this.formAddPlano = this.formBuilder.group({
      id: null,
      nome: [''],
      aplicacao: null,
      status: false,
    });
    return this.formAddPlano;
  }

  ngOnInit() {
    this.buscarPlanos();
  }

  buscarPlanos() {
    const filtros = this.filtroForm.value;
    // Dados iniciais (seu mock de exemplo)
    this.planoService.buscarPlanos(filtros).then((data) => {
      this.planos = data;
    });
  }

  //#endregion

  //#region Actions
  showAddPlanoDialog() {
    this.showAddPlano = true;
  }

  selectSistema(sistema: PlanoModel) {
    this.router.navigate(['/plano', sistema.id]);
  }

  salvarPlano() {
    var formulario = this.formAddPlano.value;
    
    console.log(formulario);
    this.planoService.salvarPlano(formulario as PlanoModel);
  }
  //#endregion
}
